var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pic-word-box" },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.list.length > 1
            ? _c("ex-picwordfirst", { attrs: { info: _vm.list[0] } })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, index) {
            return index > 0
              ? _c("ex-picword", { key: index, attrs: { info: item } })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.list.length == 1
            ? _c("ex-picwordone", { attrs: { info: _vm.list[0] } })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }